export const APP_SUBMIT_PROTECTION_ENABLE = 'APP_SUBMIT_PROTECTION_ENABLE'
export const APP_SUBMIT_PROTECTION_DISABLE = 'APP_SUBMIT_PROTECTION_DISABLE'
export const APP_CONFIGURATION_LOAD = 'APP_CONFIGURATION_LOAD'
export const APP_LOADING_DATA_ENABLE = 'APP_LOADING_DATA_ENABLE'
export const APP_LOADING_DATA_DISABLE = 'APP_LOADING_DATA_DISABLE'
